import { getLigne } from '../store/line-store.js'
import { lignes } from '../lines.js'

export class LigneIconElement extends HTMLElement {
	constructor() {
		super()

		const shadow = this.attachShadow({ mode: 'open' })

		this.button = document.createElement('button')
		this.button.textContent = this.getAttribute('ligne') || 'Ligne ?'

		const style = document.createElement('style')
		style.textContent = `
      button {
        background: ${this.getAttribute('background-color') || '#1e88e5'} ;
        color: ${this.getAttribute('color') || 'white'};
        border: none;
        padding: 8px 16px;
        border-radius: 16px;
		margin: 6px;
      }
    `
		this.setLine()
		shadow.appendChild(style)
		shadow.appendChild(this.button)

		document.addEventListener('ligne-selected', (event) => {
			this.setLine()
		})
	}

	setLine() {
		const name = getLigne()
		this.button.textContent = name
		this.button.style.background = lignes.get(name) || '#1e88e5'
	}
}

customElements.define('ligne-icon', LigneIconElement)
